'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 5,
    bottom: 22,
    left: 70,
    right: 10
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    maxGroupWidth: 20,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding
  };
};
module.exports = Params;